<template>
    <div class='mines-result-dialog'>
        <section class="board"
            :style="{'padding': '16px 18px 18px 17px !important'}"  
        >
            <img class="board__bg"
                src="@/pages/casino/minesGame/img/board-bg.png" 
                :style="{display: 'block !important'}"
            />
            <button v-for="(oCurBtn, iBtnIndex) of aButList"
                :key="iBtnIndex"
                :class="{...(oGlobal.client ? oCurBtn.oClass : {})}"
                :disabled="oGlobal.client && oCurBtn.disabled"
            >
                <!-- ↓ 爆炸时此元素不可见 display: none -->
                <div class="board__card-wrap">
                    <img class="board__card-image"
                        v-if="oCurBtn.sPicSrc"
                        :src="oCurBtn.sPicSrc"
                    />
                </div>
            </button>
        </section>
    </div>
</template>

<script lang="ts" >
export default defineComponent({name: 'MinesContent'});
</script>

<script lang="ts" setup>
import imgBomb from '@/pages/casino/minesGame/img/label-bomb.webp';
import imgDiamond from '@/pages/casino/minesGame/img/label-diamond.webp';
import type { BetHistoryType } from '~/socket/gamehistory/dto/gameHistory.dto';
import useGlobalStore from '@/stores/global';

const oGlobal = useGlobalStore();
const props = defineProps({
    history: {
        type: Object as PropType<BetHistoryType>,
        required: true,
    },
});

const aButList = computed(()=>{
    // 接口返回的雷区 fields: [10, 14, 0]
    // 说明雷区编号从0开始 
    const aResult = Array(5*5).fill(0).map((cur, idx) => {
        const iNumber = idx + 0;
        const obj = {
            iNumber,
            ...getButtonClassName(iNumber),
        };
        return obj;
    });
    return aResult;
});

// ↓ 雷区 [1,2,3]
const fields = computed(()=>{
    let {randomSeed} = props.history || {};
    if (!randomSeed) return [];
    const randomSeed01 = randomSeed.split('_')[0];
    const aResult = randomSeed01.split(',').map(cur=>{
        return Number(cur);
    });
    return aResult;
});

// ↓用户选择 
const prediction = computed(()=>{
    let aResult = props?.history?.prediction;
    console.log(aResult,'llllllllllll')
    return aResult || [];
});


function getButtonClassName(iNumber){
    const hasChosen = prediction.value.includes(iNumber); 
    const isBomb = fields.value.includes(iNumber);
    const isLostOnThis = isBomb && hasChosen;
    // ↓ 这是手动模式的类名 
    let oClass = {
        'emergence': true,
        'diamond': hasChosen && !isLostOnThis,
        'bomb': isLostOnThis,
    };
    const oResult = {
        disabled: true,
        sPicSrc: isBomb ? imgBomb : imgDiamond,
        oClass,
    };
    return oResult;
}


</script>


<style scoped lang="scss"
    src="@/pages/casino/minesGame/style/mines-board.scss"
></style>

<style scoped lang="scss">
.mines-result-dialog{
    padding: 15px 0 5px;
    .board{
        max-width: 412px;
        margin: 0 auto;
        .board__card-wrap::before,
        .diamond:after{
            content: none !important;
        }
        .board__card-wrap{
            animation: none !important;
        }
    }
}

</style>



